module.exports = __webpack_public_path__ + "img/favicon-text-reverse.8bfb2041.svg";